import { computed } from "@ember/object";
import { readOnly } from "@ember/object/computed";
import { classNames } from "@ember-decorators/component";
import { escapeExpression } from "discourse/lib/utilities";
import { i18n } from "discourse-i18n";
import DropdownSelectBoxRowComponent from "select-kit/components/dropdown-select-box/dropdown-select-box-row";
const NotificationsButtonRow = dt7948.c(class NotificationsButtonRow extends DropdownSelectBoxRowComponent {
  static {
    dt7948.g(this.prototype, "i18nPrefix", [readOnly("selectKit.options.i18nPrefix")]);
  }
  #i18nPrefix = (dt7948.i(this, "i18nPrefix"), void 0);
  static {
    dt7948.g(this.prototype, "i18nPostfix", [readOnly("selectKit.options.i18nPostfix")]);
  }
  #i18nPostfix = (dt7948.i(this, "i18nPostfix"), void 0);
  get label() {
    return escapeExpression(i18n(`${this._start}.title`));
  }
  static {
    dt7948.n(this.prototype, "label", [computed("_start")]);
  }
  get icons() {
    return [escapeExpression(this.item.icon)];
  }
  static {
    dt7948.n(this.prototype, "icons", [computed("item.icon")]);
  }
  get description() {
    return escapeExpression(i18n(`${this._start}.description`));
  }
  static {
    dt7948.n(this.prototype, "description", [computed("_start")]);
  }
  get _start() {
    return `${this.i18nPrefix}.${this.rowName}${this.i18nPostfix}`;
  }
  static {
    dt7948.n(this.prototype, "_start", [computed("i18nPrefix", "i18nPostfix", "rowName")]);
  }
}, [classNames("notifications-button-row")]);
export default NotificationsButtonRow;